// @noflow
import * as React from "react";
import * as Utils from "../lib/Util";

type Props = {
    children: React.ReactNode;
};
type State = {};

export default class Grid extends React.Component<Props, State> {
    render() {
        let className = "";
        if (Utils.getGridLayoutSettings()) {
            className = "grid-layout grid-layout-overrides";
        }
        return <div className={className}>{this.props.children}</div>;
    }
}
